import React, { useState } from "react";
import hoa11 from "../../../assets/images/hoa11.webp";

import hoa14 from "../../../assets/images/hoa14.webp";
import hoa15 from "../../../assets/images/hoa15.webp";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

export default function Slicks() {
  const images = [hoa11, hoa14, hoa15]; // Array of images
  const [currentIndex, setCurrentIndex] = useState(0); // State for the current image index

  // Function to go to the previous image
  const goToPrev = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  // Function to go to the next image
  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="flex items-center justify-between">
      <div
        className="w-10 h-10 rounded-full bg-white border border-[#E2E2E2] flex items-center justify-center cursor-pointer"
        onClick={goToPrev}
      >
        <FaChevronLeft />
      </div>
      <div>
        <img src={images[currentIndex]} alt="Slide" className=" h-96 w-full" />
      </div>
      <div
        className="w-10 h-10 rounded-full bg-white border border-[#E2E2E2] flex items-center justify-center cursor-pointer"
        onClick={goToNext}
      >
        <FaChevronRight />
      </div>
    </div>
  );
}
